import useConnector from './useConnector';

const usePortalId = () => {
  const { portalId } = useConnector();

  return portalId;
};

export default usePortalId;
